function handleSelectLinks () {
    /*
        Handle a fake select: on change go to link inside selected option
    */
    const selectELs = document.querySelectorAll('.js-select-links');

    for (const item of Array.from(selectELs)) {
        item.addEventListener('change', (event) => {
            if (event.target.value !== '' ) {
                window.location = new URL(event.target.value, window.location);
            }
        });
    }
}



export { handleSelectLinks };
